/**
 * Generate a UUIDv7 as a 32-char hex string (Shopware format, no dashes).
 * Uses a 48-bit millisecond timestamp + cryptographically random bits.
 */
export function generateUuidV7(): string {
  const timestamp = Date.now();
  const random = new Uint8Array(10);
  crypto.getRandomValues(random);

  const t = timestamp.toString(16).padStart(12, '0');
  const randHigh =
    (0x70 | (random[0] & 0x0f)).toString(16) +
    random[1].toString(16).padStart(2, '0');
  random[2] = (random[2] & 0x3f) | 0x80;
  const randLow = Array.from(random.slice(2))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return t + randHigh + randLow;
}
